const NotFound = () => {
    return (<>nicht gefunden</>)
}

export default NotFound